export default "__VITE_ASSET__CbbQ3Llc__"